<script>
import { sleep } from '@kit/utils/Sleep'

////////////////////////////////////////////////////////////////////////////////////////
//
//  Reveal.vue
//  author Alex Lowe
//
//  This is meant to be a convenience wrapper to be used in conjunction with the watch
//  and watchReveal machinery in the Hydrate injection. This places a class on the 
//  wrapper which sets the structure to an initial fade-out-state. The watchReveal
//  function is meant to animate the structure in when proper lifecycle conditions
//  in the application are satisfied
//
/////////////////////////////////////////////////////////////////////////////////////////

import { defineComponent, computed, ref, onMounted } from 'vue'

export default defineComponent({
  name: "Reveal",
  props: {
    "tag": { required:false, default:"div"},  
    "innerClass": { required:false, default:"sb sb-v"},
    "color": { required:false, default:null },
    "outerStyle": { required:false, default:""}, 
    "innerStyle": { required:false, default:""}, 
    "minHeight": {required:false, default:"400px"}, 
    "reveal": {required:false, default:"reveal_fadeIn_slideDown_50px" },
    "delayLoader": { required:false, default:0 }
  },

  setup(props) {

    const revealed = ref(false)
    const inner = ref(null)
    const delayDone = ref(false)

    onMounted(async() => {
      if(props.delayLoader > 0) {
        await sleep(props.delayLoader)
        delayDone.value = true
      } else {
        delayDone.value = true
      }
    })

    const showLoader = computed(() => {
      return delayDone.value && !revealed.value
    })

    const innerClass_ = computed(() => {
      const classes = props.innerClass
      const c = classes.constructor == Array ? classes.join(" ") : classes
      return `${c} ${props.reveal}`
    })

    const outerStyle_ = computed(() => {
      const color = props.color ? ` background:${props.color};` : ''
      if(revealed.value) {
        return `${props.outerStyle};${color}`
      } else {
        return `min-height:${props.minHeight};${props.outerStyle};${color}`
      }
    })

    const getInnerWrapper = () => {
      return inner.value
    }
    const setRevealed = (value) => {
      revealed.value = value
    }

    return { innerClass_, outerStyle_, getInnerWrapper, setRevealed, revealed, inner, delayDone, showLoader }
  }
  
});
</script>

<template>

  <component :is="tag" :style="outerStyle_">
    <div ref="inner" :class="innerClass_" :style="innerStyle">
      <template v-if="revealed">
        <slot name="reveal"></slot>
      </template>
    </div>
    <template v-if="showLoader">
      <slot name="loader"></slot>
    </template>
  </component>
</template>